import { writable } from "svelte/store";
import { loadLSStateKey, setLSStateKey } from "./localStorage";

const initialState = {};
const { subscribe, update, set } = writable(initialState);
const dataKey = "genericVoting";

const savedData = loadLSStateKey("state", dataKey);
if (savedData && typeof savedData === "object") {
  set(savedData);
}

subscribe((current) => {
  setLSStateKey("state", dataKey, current);
});
/**
 *
 * @param {Number} id
 * @param {String} campaignName
 */
const updateState = (id, campaignName, type = "vote") => {
  update((oldState) => ({
    ...oldState,
    [campaignName]: {
      [type]: (oldState[campaignName]?.[type] || [])
        .filter((el) => el !== id)
        .concat(id),
    },
  }));
};

export default {
  subscribe,
  updateState,
};
